//* Libraries imports
import { useEffect, useState } from "react";

//* Component imports
import { TemplateFieldsList } from "./TemplateFieldsList";
import { downloadFileFromUrl } from "@/utils/fileDownload";

//* Types imports
import type { TemplateOutputDTO, MappingRule } from "@/features/template/types";

function getTags(item?: TemplateOutputDTO | null): string[] {
  return item?.tags || [];
}

type TemplatePieceFormProps = {
  data: TemplateOutputDTO | null;
  selectedTag: string | null;
  onTagSelect: (tag: string) => void;
  replacements: Record<string, string>;
  mappings?: Record<string, MappingRule>;
  title?: string;
  nameLabel?: string;
};

export const TemplatePieceForm = ({
  data,
  selectedTag,
  onTagSelect,
  replacements,
  mappings,
  title = "Template",
  nameLabel = "Nome do Template",
}: TemplatePieceFormProps) => {
  const [name, setName] = useState<string>("");
  const [documentName, setDocumentName] = useState<string>("");

  useEffect(() => {
    if (data) {
      setName(data.name || "");
      setDocumentName(data.document_name || "");
    }
  }, [data]);

  const tags = getTags(data);

  const handleDownload = () => {
    if (!data?.document) return;
    let fileNameToUse = documentName || "template";
    if (
      !fileNameToUse.toLowerCase().endsWith(".ppt") &&
      !fileNameToUse.toLowerCase().endsWith(".pptx")
    ) {
      fileNameToUse += ".pptx";
    }
    downloadFileFromUrl(data.document, fileNameToUse);
  };

  return (
    <div className="flex-1 w-full flex flex-col min-h-0">
      <section className="flex flex-col w-full h-full p-6 bg-white rounded-2xl border border-gray-200 overflow-hidden gap-5">
        <div className="flex items-center justify-between">
          <h2 className="text-2xl font-semibold text-zinc-800">{title}</h2>
          {/* <button className="flex justify-center items-center size-8 hover:bg-gray-100 rounded-lg transition-colors">
            <img
              src="https://cdn.builder.io/api/v1/image/assets/a957b64922e04ac2a23d8b53cd42fbd2/de85e2454593b3b340ea8251f5ca59b1d3321b91?placeholderIfAbsent=true"
              alt="Edit"
              className="size-4 object-contain"
            />
          </button> */}
        </div>

        <hr className="border-gray-200" />

        <div className="flex flex-col gap-2">
          <label className="text-sm font-bold text-slate-500">
            {nameLabel}
          </label>
          <input
            title={nameLabel}
            placeholder="Digite o nome do template"
            type="text"
            disabled={true}
            value={name}
            className="w-full p-3 text-base text-gray-700 rounded-lg border border-gray-200 bg-white focus:outline-none focus:ring-2 focus:ring-sky-600 transition-all"
          />
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-sm font-bold text-slate-500">
            Arquivo Original
          </label>
          <div className="flex gap-3">
            <input
              title="Nome do Arquivo"
              placeholder="Nome do arquivo"
              type="text"
              disabled={true}
              value={documentName}
              className="flex-1 p-3 text-base text-gray-700 rounded-lg border border-gray-200 bg-white focus:outline-none focus:ring-2 focus:ring-sky-600 transition-all"
            />
            {data?.document && (
              <button
                onClick={handleDownload}
                className="px-4 py-2 bg-sky-50 text-sky-600 rounded-lg hover:bg-sky-100 transition-colors font-semibold whitespace-nowrap"
              >
                Ver Documento
              </button>
            )}
          </div>
        </div>

        <div className="flex-1 overflow-y-auto">
          <TemplateFieldsList
            tags={tags}
            selectedTag={selectedTag}
            onTagSelect={onTagSelect}
            replacements={replacements}
            mappings={mappings}
          />
        </div>
      </section>
    </div>
  );
};
